import * as React from 'react';
import LoggedInMiniMyOC from '@cx-web/components/composites/MiniMyOC';
import Modal from '@cx-web/components/primitives/modal-component';
import { type MyOCData } from '@cx-web/domain-types/myoc';
import { type ILabelActions } from '@cx-web/feature-i18n';

import LegacyAuthModalTrigger from '~/components/composites/legacy-auth-modal/legacy-auth-modal-trigger';

import styles from './MiniMyOC.module.css';

interface IProps {
  currentPath: string;
  isLoggedIn: boolean;
  labelActions: ILabelActions;
  myocData: MyOCData;
  onLogout?: () => void;
  onOpenCallback?: () => void;
  showProfileLink?: boolean;
  siteConfig?: { subscriptions?: { enabled?: boolean } };
  styles?: string;
  type: 'desktop' | 'burgerTop' | 'pageButton';
}

class MiniMyOC extends React.Component<IProps> {
  private handleModalOpen = (): void => {
    if (this.props.onOpenCallback) {
      this.props.onOpenCallback();
    }
  };

  shouldComponentUpdate(nextProps: IProps): boolean {
    return (
      nextProps.type !== this.props.type ||
      nextProps.isLoggedIn !== this.props.isLoggedIn ||
      nextProps.showProfileLink !== this.props.showProfileLink ||
      nextProps.siteConfig?.subscriptions?.enabled !== this.props.siteConfig?.subscriptions?.enabled
    );
  }

  private renderDesktop = (): JSX.Element | null => {
    const { isLoggedIn, labelActions } = this.props;

    if (isLoggedIn) {
      return <LoggedInMiniMyOC {...this.props} />;
    }

    const loginButton = (
      <button className={[styles.miniOCButtonDesktopAndTablet, styles.login].join(' ')} id="loginLabel">
        {labelActions.get('SIGN_IN')}
      </button>
    );

    return (
      <Modal buttonComponent={loginButton} openCallback={this.handleModalOpen} returnButton transparent>
        {this.renderOcAuthTrigger('Login')}
      </Modal>
    );
  };

  private renderBurgerTop = (): JSX.Element | null => {
    const { isLoggedIn, labelActions } = this.props;

    if (isLoggedIn) {
      return <LoggedInMiniMyOC {...this.props} />;
    }

    const loginButton = (
      <button className={[styles.miniOCButton, styles.login].join(' ')} id="loginLabel">
        {labelActions.get('SIGN_IN')}
      </button>
    );

    return (
      <Modal buttonComponent={loginButton} openCallback={this.handleModalOpen} returnButton transparent>
        {this.renderOcAuthTrigger('Login')}
      </Modal>
    );
  };

  private renderPageButtonItem = (): JSX.Element => {
    const { isLoggedIn, labelActions } = this.props;

    if (isLoggedIn) {
      return <LoggedInMiniMyOC {...this.props} />;
    }

    const mobileMyOCButton = (
      <div className={styles.loginButton}>
        <button>{labelActions.get('SIGN_UP')}</button>
      </div>
    );

    return (
      <Modal buttonComponent={mobileMyOCButton} openCallback={this.handleModalOpen} returnButton>
        {this.renderOcAuthTrigger('Signup')}
      </Modal>
    );
  };

  private renderOcAuthTrigger = (viewToOpen: 'Login' | 'Profile' | 'Signup'): JSX.Element => {
    const { currentPath, myocData } = this.props;
    return <LegacyAuthModalTrigger currentPath={currentPath} myocData={myocData} viewToOpen={viewToOpen} />;
  };

  public render = (): JSX.Element | null => {
    switch (this.props.type) {
      case 'desktop':
        return this.renderDesktop();
      case 'burgerTop':
        return this.renderBurgerTop();
      case 'pageButton':
        return this.renderPageButtonItem();
      default:
        return null;
    }
  };
}

export default MiniMyOC;
